<template>
  <div class="page-with-content">
    <div class="content">
      <!-- <section class="section ul-ticks">
        <div class="container">
          <vue-markdown class="content-inner" :source="pageContent.Content"></vue-markdown>
        </div>
      </section> -->
      <section class="section section--faq">
        <div class="container">
          <h1 class="title" v-html="pageContent['Section6 - Title']"></h1>
          <vue-markdown class="content-inner" :source="pageContent['Section6 - Content']"></vue-markdown>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import axios from 'axios';

export default {
  name: 'terms',
  components: {
    VueMarkdown,
  },
  data() {
    return {
      pageContent: '',
    };
  },
  mounted() {
    axios.get('https://cms.speedyloans.co.uk/lp1s/1')
      .then((response) => {
        // console.log(response);
        this.pageContent = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });
  },
  methods: {

  },
};

</script>


<style lang="scss">
.ul-ticks ul {
  list-style: none;
  padding: 0;
  margin-left: 1rem;

  li {
    padding-left: 1.3em;
  }
  li:before {
    content: "\f00c";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    margin-left: -1.3em;
    width: 1.3em;
    font-weight: 900;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    color: #5abb61;
  }
}

.ul-ticks ol {
  list-style-type: none !important;
  counter-reset: my-awesome-counter;
  margin-left: 1rem;
  padding: 0;

  li {
    counter-increment: my-awesome-counter;
    padding-left: 1.3em;
  }
  li::before {
    content: counter(my-awesome-counter) ". ";
    color: #5abb61;
    font-weight: bold;
    margin-right: 4px;
    width: 1.3em;
    margin-left: -1.3em;
    text-align: center;
  }
}
</style>
